module.exports = __webpack_public_path__ + "img/license_image11.6c3f95e6.png";